import api from "./instance";
import { pickData } from "./util";

/**
 * types
 */

export type LanguageMutation = {
  ns: string;
  key: string;
  value: string | null;
  language?: string;
};

export type Context = "app" | "web" | "api";

/**
 * Endpoints
 */

export const getLanguage = (context: Context, language: string) =>
  api.get<object>(`/lang/${context}/${language}`).then(pickData);

export const createLanguage = (language: string) => {
  api.post(`/lang`, { language });
};

export const removeLanguage = (language: string) =>
  api.delete(`/lang/${language}`);

export const mutateEntry = (
  context: Context,
  mutation: LanguageMutation | LanguageMutation[],
) => api.put(`/lang/${context}/entry`, mutation);
export const createEntry = (
  context: Context,
  mutation: LanguageMutation | LanguageMutation[],
) => api.post(`/lang/${context}/entry`, mutation);
export const deleteEntry = (context: Context, ns: string, key: string) =>
  api.delete(`/lang/${context}/entry/${ns}/${key}`);

export const renameKey = (
  context: Context,
  ns: string,
  oldKey: string,
  newKey: string,
) => api.put(`/lang/${context}/key`, { ns, oldKey, newKey });

export const renameNamespace = (
  context: Context,
  oldNs: string,
  newNs: string,
) => api.put(`/lang/${context}/ns/${oldNs}`, { ns: newNs });
export const createNamespace = (context: Context, ns: string) =>
  api.post(`/lang/${context}/ns`, { ns });
export const deleteNamespace = (context: Context, ns: string) =>
  api.delete(`/lang/${context}/ns/${ns}`);

export const getAvailableLanguages = () =>
  api.get<string[]>(`/lang`).then(pickData);
